module.exports = __webpack_public_path__ + "img/icon32.34762056.png";